import React, { useLayoutEffect, useRef, useState } from "react";
import "./styles/NavigatorСodeApp.css";
import { GameStyleType } from "./Components/types/types";
import Board from "./Components/Board";
import TopBar from "./Components/TopBar";
import Helppanel from "./Components/Helppanel";
import { GameProvider } from "./GameContext";
import { TimerProvider } from "./TimerContext";
import FullscreenToggle from "./Components/hooks/FullscreenToggle";
import TextArea from "./Components/render/TextArea";

const AppContent: React.FC<GameStyleType> = ({ random, rounds, type }) => {
 const sceneRef = useRef<HTMLDivElement>(null);
  const [sceneHeight, setSceneHeight] = useState(0);

 
  useLayoutEffect(() => {
    const scene = sceneRef.current;

    if (!scene) return;

    const resize = () => {
      const height = scene.offsetHeight;
      setSceneHeight((height / window.innerWidth) * 100);
    };

    resize();

    const observer = new ResizeObserver(resize);
    observer.observe(scene);

    return () => observer.disconnect();
  }, []);
  return (
    <div id="navigatorСode-content">
      <div className="navigatorСode-conteiner">
        <div className="navigatorСode-titleGame">
          <div className="navigatorСode-mainsubtitle">{type ===1?"Когда известен путь":"Истина в сетке"}</div>
          <FullscreenToggle />
        </div>
        <div className="navigatorСode-game-wrapper">
          <div className="navigatorСode-Scene" ref={sceneRef}>
            <TopBar />
            <Board random={random} rounds={rounds} type={type} />
          </div>
          <TextArea sceneHeight={sceneHeight} />
        </div>
        <Helppanel />
      </div>
    </div>
  );
};

const App: React.FC<GameStyleType> = (props) => {
  return (
    <GameProvider>
      <TimerProvider>
        <AppContent
          random={props.random}
          rounds={props.rounds}
          type={props.type}
        />
      </TimerProvider>
    </GameProvider>
  );
};

export default App;
